import lineColors from './lineColors';

const palettes = [
  // Old default colors (lineColors)
  [],
  // 1 metric color palette
  [{ name: 'color1', value: '#1453E5' }],
  // 2 metrics color palette
  [
    { name: 'color1', value: '#1453E5' },
    { name: 'color2', value: '#D54D68' },
  ],
  // 3 metrics color palette
  [
    { name: 'color1', value: '#1453E5' },
    { name: 'color2', value: '#77CFD6' },
    { name: 'color3', value: '#D54D68' },
  ],
  // 4 metrics color palette
  [
    { name: 'color1', value: '#1453E5' },
    { name: 'color2', value: '#77CFD6' },
    { name: 'color3', value: '#F1AE9A' },
    { name: 'color4', value: '#D54D68' },
  ],
  // 5 metrics color palette
  [
    { name: 'color1', value: '#1453E5' },
    { name: 'color2', value: '#77CFD6' },
    { name: 'color3', value: '#F1AE9A' },
    { name: 'color4', value: '#D54D68' },
    { name: 'color5', value: '#73076C' },
  ],
  // 6 metrics color palette
  [
    { name: 'color1', value: '#1453E5' },
    { name: 'color2', value: '#77CFD6' },
    { name: 'color3', value: '#FFEA99' },
    { name: 'color4', value: '#F1AE9A' },
    { name: 'color5', value: '#D54D68' },
    { name: 'color6', value: '#73076C' },
  ],
  // 7 metrics color palette
  [
    { name: 'color1', value: '#1553E5' },
    { name: 'color2', value: '#38ACEA' },
    { name: 'color3', value: '#77CFD6' },
    { name: 'color4', value: '#FFEA99' },
    { name: 'color5', value: '#F1AE9A' },
    { name: 'color6', value: '#D54D68' },
    { name: 'color7', value: '#73076C' },
  ],
  // 8 metrics color palette
  [
    { name: 'color1', value: '#06147F' },
    { name: 'color2', value: '#1453E5' },
    { name: 'color3', value: '#38ACEA' },
    { name: 'color4', value: '#8BDFD4' },
    { name: 'color5', value: '#FFEA99' },
    { name: 'color6', value: '#F1AE9A' },
    { name: 'color7', value: '#D54D68' },
    { name: 'color8', value: '#73076C' },
  ],
  // 9 metrics color palette
  [
    { name: 'color1', value: '#06147F' },
    { name: 'color2', value: '#1453E5' },
    { name: 'color3', value: '#0078F6' },
    { name: 'color4', value: '#38ACEA' },
    { name: 'color5', value: '#8BDFD4' },
    { name: 'color6', value: '#FFEA99' },
    { name: 'color7', value: '#F1AE9A' },
    { name: 'color8', value: '#D54D68' },
    { name: 'color9', value: '#73076C' },
  ],
  // 10 metrics color palette
  [
    { name: 'color1', value: '#06147F' },
    { name: 'color2', value: '#1453E5' },
    { name: 'color3', value: '#0078F6' },
    { name: 'color4', value: '#38ACEA' },
    { name: 'color5', value: '#8BDFD4' },
    { name: 'color6', value: '#FFEA99' },
    { name: 'color7', value: '#F9C9A3' },
    { name: 'color8', value: '#F19A9B' },
    { name: 'color9', value: '#D54D68' },
    { name: 'color10', value: '#73076C' },
  ],
  // 11 metrics color palette
  [
    { name: 'color1', value: '#06147F' },
    { name: 'color2', value: '#172BCB' },
    { name: 'color3', value: '#0078F6' },
    { name: 'color4', value: '#38ACEA' },
    { name: 'color5', value: '#CADEA7' },
    { name: 'color6', value: '#FFEA99' },
    { name: 'color7', value: '#F9C9A3' },
    { name: 'color8', value: '#F19A9B' },
    { name: 'color9', value: '#D54D68' },
    { name: 'color10', value: '#8E1763' },
    { name: 'color11', value: '#6E0773' },
  ],
  // 12 metrics color palette
  [
    { name: 'color1', value: '#06147F' },
    { name: 'color2', value: '#172BCB' },
    { name: 'color3', value: '#0078F6' },
    { name: 'color4', value: '#38ACEA' },
    { name: 'color5', value: '#56B9D1' },
    { name: 'color6', value: '#CADEA7' },
    { name: 'color7', value: '#FFEA99' },
    { name: 'color8', value: '#F9C9A3' },
    { name: 'color9', value: '#F19A9B' },
    { name: 'color10', value: '#D54D68' },
    { name: 'color11', value: '#8E1763' },
    { name: 'color12', value: '#48186B' },
  ],
];

const generateLineColors = palleteLength => (
  [...palettes[Math.max(0, Math.min((palleteLength), palettes.length - 1))], ...lineColors]
);

export default generateLineColors;
